const Chapter4Status = [
  { value: 1, name: 'USWHDAgentFi', description: 'US WHD Agent - FI' },
  { value: 2, name: 'USWHDAgentOther', description: 'US WHD Agent - Other' },
  { value: 3, name: 'TerritoryFinancialInstitution', description: 'Territory Financial Institution' },
  { value: 4, name: 'TerritoryFiUsPerson', description: 'TerritoryFFI - US' },
  { value: 5, name: 'ParticipatingFfi', description: 'Participating FFI' },
  { value: 6, name: 'ReportingModel2Ffi', description: 'Reporting Model 2 FFI' },
  { value: 7, name: 'ReportingModel1Ffi', description: 'Reporting Model 1 FFI' },
  { value: 8, name: 'SponsoredFfi', description: 'Sponsored FFI' },
  { value: 9, name: 'RegisteredDeemedCompliantFfi', description: 'Registered Deemed Compliant FFI' },
  { value: 10, name: 'CertifiedDeemedCompliantLtdLifeInvestmentEntity', description: 'Certified Deemed Compliant Limited Life Dept Investment Entity' },
  { value: 11, name: 'CertifiedDeemedCompliantFfiLowValueAccounts', description: 'Certified Deemed Compliant FFI Low Value Accounts' },
  { value: 12, name: 'CertifiedDeemedCompliantNonRegisteringLocalBank', description: 'Certified Deemed Compliant Non Registering Local Bank' },
  { value: 13, name: 'CertifiedDeemedCompliantSponsored', description: 'Certified Deemed Compliant Sponsored' },
  { value: 14, name: 'CertifiedDeemedCompliantInvestmentAdvisors', description: 'Certified Deemed Compliant Investment Advisors' },
  { value: 15, name: 'NonParticipatingFfi', description: 'Non Participating FFI' },
  { value: 16, name: 'OwnerDocumentedFfi', description: 'Owner Documented FFI' },
  { value: 17, name: 'UsBranchUsPerson', description: 'US Branch - US Person' },
  { value: 18, name: 'UsBranchSection1471', description: 'US Branch - Section 1471' },
  { value: 19, name: 'PassiveNffe', description: 'Passive NFFE' },
  { value: 20, name: 'PassiveNffeNoUsOwners', description: 'PSVNFFE - No US Owner' },
  { value: 21, name: 'PubliclyTradedNffeOrNffeAffiliate', description: 'Publicly Traded NFFE Affiliate' },
  { value: 22, name: 'ActiveNffe', description: 'Active NFFE' },
  { value: 23, name: 'Individual', description: 'Individual' },
  { value: 24, name: 'Organization501C', description: '501c Organization' },
  { value: 25, name: 'ExceptedTerritoryNffe', description: 'Excepted Territory NFFE' },
  { value: 26, name: 'ExceptedTerritoryNffeOther', description: 'Excepted Territory NFFE - Other' },
  { value: 27, name: 'ExemptBeneficialOwner', description: 'Exempt Beneficial Owner' },
  { value: 28, name: 'EntityOwnedByBeneficialOwners', description: 'Entity Owned By Beneficial Owner' },
  { value: 29, name: 'UnknownRecipient', description: 'Unknown Recipient' },
  { value: 30, name: 'RecalcitrantAccountHolder', description: 'Recalcitrant Account Holder' },
  { value: 31, name: 'NonReportingIgaFfi', description: 'Non Reporting IGA FFI' },
  { value: 32, name: 'DirectReportingNffe', description: 'Direct Reporting NFFE' },
  { value: 33, name: 'UsReportableAccount', description: 'US Reportable Account' },
  { value: 34, name: 'NonconsentingUsAccount', description: 'Nonconsenting US Acc.' },
  { value: 35, name: 'SponsoredDirectReportingNffe', description: 'Sponsored Direct Reporting NFFE' },
  { value: 36, name: 'ExceptedInterAffiliateFfi', description: 'Excepted Inter Affiliate FFI' },
  { value: 37, name: 'UndocumentedPreExistingObligation', description: 'Undocumented PreExisting Obligation' },
  { value: 38, name: 'UsBranchEci', description: 'US Branch - ECI' },
  { value: 39, name: 'NonFinancialAccount', description: 'Non Financial Account' },
  { value: 40, name: 'PassiveNFFEFfi', description: 'Passive NFFE FFI' },
  { value: 41, name: 'Nffe1472Withholding', description: 'NFFE - 1472 Withholding' },
  { value: 42, name: 'RecalcitrantPoolNonUsIndicia', description: 'Recalcitrant Pool - No U.S. Indicia', whsPooledStatus: true },
  { value: 43, name: 'RecalcitrantPoolUsIndicia', description: 'Recalcitrant Pool - U.S. Indicia', whsPooledStatus: true },
  { value: 44, name: 'RecalcitrantPoolDormantAccount', description: 'Recalcitrant Pool - Dormant Account', whsPooledStatus: true },
  { value: 45, name: 'RecalcitrantPoolUsPersons', description: 'Recalcitrant Pool - U.S. Persons', whsPooledStatus: true },
  { value: 46, name: 'RecalcitrantPoolPassiveNffe', description: 'Recalcitrant Pool - Passive NFFEs', whsPooledStatus: true },
  { value: 47, name: 'NonParticipatingFfiPool', description: 'Non Participating FFI Pool', whsPooledStatus: true },
  { value: 48, name: 'UsPayeesPool', description: 'US Payees Pool', whsPooledStatus: true },
  { value: 49, name: 'QiRecalcitrantPoolGeneral', description: 'QI - Recalcitrant Pool General', whsPooledStatus: true },
  { value: 50, name: 'UswaForeignBranchFi', description: 'USWA - Foreign Branch' },
  { value: 80, name: 'InternationalOrganization', description: 'International Organization' },
  { value: 100, name: 'USPersonSpecified', description: 'U.S. Person (Specified)' },
  { value: 101, name: 'USPersonExempt', description: 'U.S. Person (Non-Specified)' }
];

Chapter4Status.findByName = (statusName) => {
  if (!statusName || statusName.length <= 0) {
    return null;
  }

  const status = Chapter4Status.find(x => x.name.toLowerCase() === statusName.toLowerCase());
  return status || null;
};

export default Chapter4Status;
